import { useParams } from "react-router-dom";
import { useGetCustomerViewDetailsQuery } from "../../../Service/customers";
import { formatDate } from "../PotentialLeads/Utils/TableHeadlist";
import { formatDateString } from "./Utils";
import { useEffect } from "react";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import { useDispatch } from "react-redux";

const CustomerViewDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { data: CustomerContactData } = useGetCustomerViewDetailsQuery(id, {
    refetchOnMountOrArgChange: true,
  });
  console.log(CustomerContactData, "CustomerContactData");
  const { contact, customer, medicalDetails, Appointment, Customer_log } =
    CustomerContactData || {};

  const data = [
    {
      name: customer?.customerName || "N/A",
      Sub: [
        {
          name: "Case ID",
          value: customer?.caseId || "N/A",
          icon: "remember_me",
        },
        {
          name: "Date Of Birth",
          value: customer?.dateOfBirth
            ? formatDate(customer.dateOfBirth)
            : "N/A",
          icon: "cake",
        },
        { name: "Sex", value: customer?.sex || "N/A", icon: "wc" },
        {
          name: "Referred by",
          value: customer?.referredBy || "N/A",
          icon: "step_over",
        },
        {
          name: "Occupation",
          value: customer?.occupation || "N/A",
          icon: "work",
        },
      ],
    },
    {
      name: "Contact Information",
      Sub: [
        { name: "Phone 1", value: contact?.phone1 || "N/A", icon: "call" },
        { name: "Phone 2", value: contact?.phone2 || "N/A", icon: "call" },
        { name: "Email", value: contact?.email1 || "N/A", icon: "mail" },
        { name: "Address", value: contact?.area || "N/A", icon: "home" },
        { name: "City", value: contact?.area || "N/A", icon: "location_city" },
      ],
    },
    {
      name: "Medical Details",
      Sub: [
        {
          name: "Blood Group",
          value: medicalDetails?.bloodGroup || "N/A",
          icon: "water_drop",
        },
        {
          name: "Height",
          value: medicalDetails?.height ? `${medicalDetails.height} cm` : "N/A",
          icon: "height",
        },
        {
          name: "Weight",
          value: medicalDetails?.weight ? `${medicalDetails.weight} kg` : "N/A",
          icon: "monitor_weight",
        },
        {
          name: "Blood Pressure",
          value: medicalDetails?.bp || "N/A",
          icon: "bloodtype",
        },
        {
          name: "Temperature",
          value: medicalDetails?.temperature
            ? `${medicalDetails.temperature}`
            : "N/A",
          icon: "thermostat",
        },
        {
          name: "SPO",
          sub: "2",
          value: medicalDetails?.spo2 ? `${medicalDetails.spo2}` : "N/A",
          icon: "globe_asia",
        },
        {
          name: "Drug Allergy",
          value: medicalDetails?.drugAllergy || "N/A",
          icon: "allergies",
        },
      ],
    },
  ];

  useEffect(() => {
    const data: any = {
      first: `${customer?.customerName}`,
    };
    dispatch(Change(data));
  }, [customer]);
  return (
    <div className="row  p-2 gap-1">
      <div className="col-3  card overflow-auto" style={{ maxHeight: "80vh" }}>
        {data.map((section) => (
          <div className="mt-3" key={section.name}>
            <div>
              <span className="fw-600 f-24">{section.name}</span>
            </div>
            <div>
              {section.Sub.map((item) => (
                <div
                  className="d-flex gap-1 align-items-center mb-2 mt-4"
                  key={item.name}
                >
                  <span className="material-symbols-outlined">{item.icon}</span>
                  <span className="f-14 fw-400" style={{ color: "#696969" }}>
                    {item.name}{" "}
                    {item.sub && (
                      <span>
                        <sub>{item.sub}</sub>
                      </span>
                    )}
                    :<span style={{ color: "#000000" }}> {item.value}</span>
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="col-3  card overflow-auto" style={{ maxHeight: "80vh" }}>
        <div className="d-flex flex-column gap-2 card p-2 mt-2">
          <span className="f-18 fw-500 fw-bold">Status</span>
          <span>{customer?.customerStatus}</span>
        </div>
        <div className="d-flex flex-column gap-2 card p-2 mt-2">
          <span className="f-18 fw-500 fw-bold">Appointment</span>
          <span className="fw-400 f-12">Next clinical appointment on</span>
          <span className="d-flex align-items-center">
            <span className="material-symbols-outlined me-2">stethoscope</span>
            {Appointment?.[0]?.consultantName}
          </span>
          <span className="d-flex gap-2 f-21 fw-500">
            <span className="d-flex align-items-center">
              <span className="material-symbols-outlined me-2">
                calendar_clock
              </span>
              {Appointment?.[0]?.appointmentDate || ""}
            </span>
            <span className="d-flex align-items-center">
              <span className="material-symbols-outlined me-2">schedule</span>
              {Appointment?.[0]?.appointmentTime || ""}
            </span>
          </span>
        </div>
      </div>
      <div className="col-5 card overflow-auto" style={{ height: "80vh" }}>
        <div>
          <span className="f-18 fw-500 fw-bold">Logs</span>
        </div>
        <table className="table ">
          <thead>
            <tr>
              <th>Date</th>
              <th>Medium</th>
              <th>Status</th>
              <th>Comments</th>
            </tr>
          </thead>
          <tbody>
            {Customer_log?.map((item: any, index: number) => (
              <tr key={index}>
                <td>{formatDateString(item.updatedAt) || "N/A"}</td>
                <td>{item.medium || "N/A"}</td>
                <td>{item.status}</td>
                <td>{item.comments}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomerViewDetails;
